/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiTabChartResponseFromJSON, ApiTabChartResponseToJSON, } from './ApiTabChartResponse';
import { ApiTabElementTypeFromJSON, ApiTabElementTypeToJSON, } from './ApiTabElementType';
export function ApiTabElementResponseFromJSON(json) {
    return ApiTabElementResponseFromJSONTyped(json, false);
}
export function ApiTabElementResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiTabChartResponseFromJSON(json['chart']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'elements': !exists(json, 'elements') ? undefined : (json['elements'].map(ApiTabElementResponseFromJSON)),
        'h': !exists(json, 'h') ? undefined : json['h'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : ApiTabElementTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'w': !exists(json, 'w') ? undefined : json['w'],
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
    };
}
export function ApiTabElementResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiTabChartResponseToJSON(value.chart),
        'description': value.description,
        'elements': value.elements === undefined ? undefined : (value.elements.map(ApiTabElementResponseToJSON)),
        'h': value.h,
        'id': value.id,
        'name': value.name,
        'type': ApiTabElementTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'w': value.w,
        'x': value.x,
        'y': value.y,
    };
}
